import About from "../components/sections/About";
import Process from "../components/sections/Process";
import Testimonials from "../components/sections/Testimonials";
import { motion } from "framer-motion";
import useSEO from "../lib/useSEO";

export default function AboutPage() {
    useSEO({
        title: "About Thooyra Technologies — Chennai Software Engineering Studio",
        description:
            "Learn about Thooyra Technologies, a Chennai-based software engineering studio building modern ERP, SaaS and business software with senior engineering depth and product taste.",
        path: "/about",
    });
    return (
        <main data-testid="about-page">
            <section className="relative pt-36 pb-12 md:pt-44 md:pb-16 overflow-hidden">
                <div
                    aria-hidden
                    className="absolute inset-0 -z-10 pointer-events-none"
                >
                    <div className="absolute top-10 left-1/4 w-[420px] h-[420px] rounded-full bg-violet-300/30 dark:bg-violet-500/20 blur-[120px] animate-blob" />
                </div>
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <motion.div
                        initial={{ opacity: 0, y: 14 }}
                        animate={{ opacity: 1, y: 0 }}
                    >
                        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                            About us
                        </div>
                        <h1 className="font-display font-light text-5xl md:text-7xl tracking-tighter leading-[1.02] max-w-4xl">
                            We build calmly, ship deliberately and care about{" "}
                            <span className="italic font-medium">craft</span>.
                        </h1>
                        <p className="mt-8 max-w-2xl text-muted-foreground text-lg leading-relaxed">
                            Thooyra Technologies is a Chennai-based software
                            engineering studio. We help businesses move from
                            spreadsheets, legacy systems and stitched-together
                            tools to modern, beautiful, scalable software.
                        </p>
                    </motion.div>
                </div>
            </section>
            <About />
            <Process />
            <Testimonials />
        </main>
    );
}
